import type { BoolQuestionAnswerEditorViewModel } from '@/features/jobs/questions/bool/BoolQuestionAnswerEditorViewModel'
import { observer } from 'mobx-react-lite'
import { BoolQuestionAnswerEditor } from '@/features/jobs/questions/bool/components/BoolQuestionAnswerEditor/index'

interface BoolQuestionAnswerEditorContainerProps {
  editorVm: BoolQuestionAnswerEditorViewModel
  questionId: string
  'aria-labelledby'?: string
  'aria-describedby'?: string
  isDisabled?: boolean
}

/**
 * Bool Answer Editor Container
 */
export const BoolQuestionAnswerEditorContainer = observer(
  function BoolQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: BoolQuestionAnswerEditorContainerProps) {
    return (
      <BoolQuestionAnswerEditor
        value={editorVm.value}
        onChange={editorVm.respond}
        testId={`bool-question-answer-editor-${questionId}`}
        noTestId={`bool-question-answer-editor-option-no-${questionId}`}
        yesTestId={`bool-question-answer-editor-option-yes-${questionId}`}
        {...rest}
      />
    )
  },
)
